"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = WrapperSegment;
var _react = _interopRequireWildcard(require("react"));
var _reactComponents = require("@synerg/react-components");
var _lodash = require("lodash");
var _axios = _interopRequireDefault(require("axios"));
var _qs = _interopRequireDefault(require("qs"));
var _get = _interopRequireDefault(require("lodash/get"));
require("./contextualize.scss");
var _operationTabContent = _interopRequireDefault(require("./operationTabContent/operationTabContent"));
var _promoBoxes = _interopRequireDefault(require("./operationsPromoBoxes/promoBoxes"));
var _toast = _interopRequireDefault(require("../common/toast"));
var _apisEndUser = _interopRequireDefault(require("./apisEndUser"));
var _search = _interopRequireDefault(require("../searchfilter/search"));
var _eventCodeTabContent = _interopRequireDefault(require("./operationTabContent/eventCodeTabContent"));
var _commitChanges = _interopRequireDefault(require("../commitRemovalAPIs/commitChanges"));
var _endpoints = require("./utilities/endpoints");
var _apiUtils = require("./utilities/apiUtils");
var _devPortalContext = _interopRequireDefault(require("./utilities/devPortalContext"));
var _constants = require("./utilities/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function WrapperSegment(_ref) {
  var loading = _ref.loading,
    history = _ref.history,
    projectDetail = _ref.projectDetail,
    endUserApiTabActive = _ref.endUserApiTabActive,
    setEndUserApiTabActive = _ref.setEndUserApiTabActive,
    filteredApis = _ref.filteredApis,
    hasFilteredApis = _ref.hasFilteredApis,
    events = _ref.events,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? "Development APIs" : _ref$title,
    endUser = _ref.endUser,
    projectType = _ref.projectType,
    project_use_case_host = _ref.project_use_case_host,
    openFocusPane = _ref.openFocusPane,
    setSelectedSegment = _ref.setSelectedSegment,
    isDomainSubCategoryBusy = _ref.isDomainSubCategoryBusy,
    disableAddApisBtn = _ref.disableAddApisBtn,
    changeHistoryRedirectUrl = _ref.changeHistoryRedirectUrl,
    existingAPIs = _ref.existingAPIs,
    existingEvents = _ref.existingEvents,
    scopeLastModified = _ref.scopeLastModified,
    refreshProjectConsumerDetails = _ref.refreshProjectConsumerDetails,
    hideHeader = _ref.hideHeader;
  var projectId = projectDetail._id,
    b2bConsumerAppID = projectDetail.b2bConsumerAppID,
    b2cConsumerAppID = projectDetail.b2cConsumerAppID,
    platform = projectDetail.platform;
  var segments = [{
    label: "Data connector",
    value: 0,
    disabled: !b2bConsumerAppID
  }, {
    label: "End-user/SSO",
    value: 1,
    disabled: !b2cConsumerAppID
  }];
  var isEndUserActive = !!(endUser ? b2cConsumerAppID : !b2bConsumerAppID);
  var isDataConnectorActive = !!(!isEndUserActive && b2bConsumerAppID);
  var _useState = (0, _react.useState)(projectType || "api-central"),
    _useState2 = _slicedToArray(_useState, 2),
    projectApp = _useState2[0],
    setProjectApp = _useState2[1];
  var _useState3 = (0, _react.useState)([]),
    _useState4 = _slicedToArray(_useState3, 2),
    apis = _useState4[0],
    setApis = _useState4[1];
  var removeDeletes = filteredApis.filter(function (api) {
    return api.verb !== "DELETE" && api.verb !== "PATCH";
  });
  var _useState5 = (0, _react.useState)(filteredApis ? (0, _apiUtils.categorizeAPIs)(removeDeletes) : []),
    _useState6 = _slicedToArray(_useState5, 1),
    categorizedAPIs = _useState6[0];
  var _useState7 = (0, _react.useState)((0, _apiUtils.categorizeAPIs)(events ? events : [])),
    _useState8 = _slicedToArray(_useState7, 1),
    categorizedEventAPIs = _useState8[0];
  var _useState9 = (0, _react.useState)([]),
    _useState10 = _slicedToArray(_useState9, 2),
    useCases = _useState10[0],
    setUseCases = _useState10[1];
  (0, _react.useEffect)(function () {
    function getProjectUseCases() {
      return _getProjectUseCases.apply(this, arguments);
    }
    function _getProjectUseCases() {
      _getProjectUseCases = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var url, _yield$axios, data, errorMessage;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              url = project_use_case_host + _endpoints.URLS[projectApp]["get"]["project-use-case"];
              _context.next = 4;
              return (0, _axios.default)(url);
            case 4:
              _yield$axios = _context.sent;
              data = _yield$axios.data;
              setUseCases(data);
              _context.next = 13;
              break;
            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](0);
              errorMessage = (0, _get.default)(_context.t0, "response.data.message", "Error occurred when trying to get project use cases. Please try again.");
              handleError(errorMessage);
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 9]]);
      }));
      return _getProjectUseCases.apply(this, arguments);
    }
    if ((0, _endpoints.isSelfService)(projectApp)) {
      getProjectUseCases();
    }
    setProjectApp(projectType || "api-central");
    setApis(filteredApis.filter(function (api) {
      return api.verb !== "DELETE";
    }));
  }, [filteredApis]);
  var onSegmentChange = function onSegmentChange(event) {
    setEndUserApiTabActive(event.detail);
  };
  var goToDataConnector = function goToDataConnector() {
    return history.push("/projects/".concat(projectId, "/apis"));
  };
  var goToEndUserApp = function goToEndUserApp() {
    return history.push("/projects/".concat(projectId, "/apis"));
  };
  (0, _react.useEffect)(function () {
    if ((0, _endpoints.isSelfService)(projectApp)) {
      if (endUserApiTabActive === 0) {
        goToDataConnector();
      } else {
        goToEndUserApp();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [endUserApiTabActive]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", null, !hideHeader && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "text-heading-06 font-black mt-6 mb-4"
  }, title), /*#__PURE__*/_react.default.createElement("span", {
    className: "text-body-03"
  }, "Reference the APIs and event subscriptions you can currently access based on your specific use case.")), (0, _endpoints.isSelfService)(projectApp) && /*#__PURE__*/_react.default.createElement("div", null, platform !== "datacloud" && /*#__PURE__*/_react.default.createElement("div", {
    className: "flex my-10 justify-center"
  }, /*#__PURE__*/_react.default.createElement(_reactComponents.SdfSegmentedControl, {
    items: segments,
    onSdfChange: function onSdfChange(event) {
      return onSegmentChange(event);
    },
    selectedIndex: endUserApiTabActive
  })), endUserApiTabActive === 0 && isDataConnectorActive && /*#__PURE__*/_react.default.createElement(Contextualize, {
    loading: loading,
    projectDetail: projectDetail,
    filteredApis: apis,
    hasFilteredApis: hasFilteredApis,
    events: categorizedEventAPIs,
    history: history,
    host: _endpoints.host,
    projectApp: projectApp,
    categorizedAPIs: categorizedAPIs,
    useCases: useCases,
    openFocusPane: openFocusPane,
    setSelectedSegment: setSelectedSegment
  }), endUserApiTabActive === 1 && /*#__PURE__*/_react.default.createElement(_apisEndUser.default, {
    projectDetail: projectDetail,
    host: project_use_case_host,
    projectApp: projectApp
  })), ((0, _endpoints.isApiCentral)(projectApp) || (0, _endpoints.isSelfServiceSiProject)(projectApp)) && /*#__PURE__*/_react.default.createElement(Contextualize, {
    loading: loading,
    projectDetail: projectDetail,
    filteredApis: apis,
    hasFilteredApis: hasFilteredApis,
    events: categorizedEventAPIs,
    history: history,
    host: _endpoints.host,
    projectApp: projectApp,
    categorizedAPIs: categorizedAPIs,
    openFocusPane: openFocusPane,
    setSelectedSegment: setSelectedSegment,
    isDomainSubCategoryBusy: isDomainSubCategoryBusy,
    disableAddApisBtn: disableAddApisBtn,
    changeHistoryRedirectUrl: changeHistoryRedirectUrl,
    scopeLastModified: scopeLastModified,
    existingAPIs: existingAPIs,
    existingEvents: existingEvents,
    refreshProjectConsumerDetails: refreshProjectConsumerDetails,
    hideHeader: hideHeader
  })));
}
function Contextualize(_ref2) {
  var _Object$keys2, _Object$keys3;
  var loading = _ref2.loading,
    projectDetail = _ref2.projectDetail,
    filteredApis = _ref2.filteredApis,
    hasFilteredApis = _ref2.hasFilteredApis,
    _ref2$events = _ref2.events,
    events = _ref2$events === void 0 ? {} : _ref2$events,
    history = _ref2.history,
    host = _ref2.host,
    projectApp = _ref2.projectApp,
    _ref2$categorizedAPIs = _ref2.categorizedAPIs,
    categorizedAPIs = _ref2$categorizedAPIs === void 0 ? {} : _ref2$categorizedAPIs,
    openFocusPane = _ref2.openFocusPane,
    setSelectedSegment = _ref2.setSelectedSegment,
    _ref2$useCases = _ref2.useCases,
    useCases = _ref2$useCases === void 0 ? [] : _ref2$useCases,
    isDomainSubCategoryBusy = _ref2.isDomainSubCategoryBusy,
    disableAddApisBtn = _ref2.disableAddApisBtn,
    changeHistoryRedirectUrl = _ref2.changeHistoryRedirectUrl,
    scopeLastModified = _ref2.scopeLastModified,
    existingEvents = _ref2.existingEvents,
    existingAPIs = _ref2.existingAPIs,
    refreshProjectConsumerDetails = _ref2.refreshProjectConsumerDetails,
    hideHeader = _ref2.hideHeader;
  var _projectDetail$caseDi = projectDetail.caseDisplay,
    caseDisplay = _projectDetail$caseDi === void 0 ? "" : _projectDetail$caseDi,
    _projectDetail$caseDe = projectDetail.caseDescription,
    caseDescription = _projectDetail$caseDe === void 0 ? "" : _projectDetail$caseDe,
    caseDocumentation = projectDetail.caseDocumentation,
    legacy = projectDetail.legacy,
    caseID = projectDetail.caseID,
    platform = projectDetail.platform;
  var matchedUseCase = (useCases && useCases.length > 0 ? useCases.find(function (useCase) {
    return useCase._id === caseID;
  }) : {}) || {};
  var documentation = matchedUseCase.documentation;
  var firstDocument = caseDocumentation ? caseDocumentation[0] : null;
  var useCaseDocument = documentation ? documentation[0] : null;
  var projectId = projectDetail._id;
  var projectIdEncrypted = (0, _get.default)(projectDetail, '_id', '');
  var consumerApplicationID = (0, _get.default)(projectDetail, 'b2bConsumerAppID', '');
  var _useState11 = (0, _react.useState)(false),
    _useState12 = _slicedToArray(_useState11, 2),
    toast = _useState12[0],
    setToast = _useState12[1];
  var _useState13 = (0, _react.useState)("ALL"),
    _useState14 = _slicedToArray(_useState13, 2),
    verbTab = _useState14[0],
    setVerbTab = _useState14[1];
  var _useState15 = (0, _react.useState)(""),
    _useState16 = _slicedToArray(_useState15, 2),
    searchedText = _useState16[0],
    setSearchedText = _useState16[1];
  var _useState17 = (0, _react.useState)(false),
    _useState18 = _slicedToArray(_useState17, 2),
    spinner = _useState18[0],
    setSpinner = _useState18[1];
  var _useState19 = (0, _react.useState)({
      label: "All",
      value: "all"
    }),
    _useState20 = _slicedToArray(_useState19, 2),
    selectedCategory = _useState20[0],
    setSelectedCategory = _useState20[1];
  var _useState21 = (0, _react.useState)(events),
    _useState22 = _slicedToArray(_useState21, 2),
    eventApis = _useState22[0],
    setEventApis = _useState22[1];
  var _useState23 = (0, _react.useState)(0),
    _useState24 = _slicedToArray(_useState23, 2),
    eventApisCount = _useState24[0],
    setEventApisCount = _useState24[1];
  var projectAppForUrl = (0, _endpoints.isSelfServiceSiProject)(projectApp) ? "self_service" : projectApp;
  var _useState25 = (0, _react.useState)(""),
    _useState26 = _slicedToArray(_useState25, 2),
    searchEventNotification = _useState26[0],
    setSearchEventNotification = _useState26[1];
  var _useState27 = (0, _react.useState)(categorizedAPIs),
    _useState28 = _slicedToArray(_useState27, 2),
    categorized = _useState28[0],
    setCategorized = _useState28[1];
  var _useState29 = (0, _react.useState)({}),
    _useState30 = _slicedToArray(_useState29, 2),
    paginatedAPIs = _useState30[0],
    setPaginatedAPIs = _useState30[1];
  var _useState31 = (0, _react.useState)(1),
    _useState32 = _slicedToArray(_useState31, 2),
    pageNo = _useState32[0],
    setPageNo = _useState32[1];
  var _useState33 = (0, _react.useState)(10),
    _useState34 = _slicedToArray(_useState33, 2),
    pageSize = _useState34[0],
    setPageSize = _useState34[1];
  var _useState35 = (0, _react.useState)(0),
    _useState36 = _slicedToArray(_useState35, 2),
    start = _useState36[0],
    setStart = _useState36[1];
  var _useState37 = (0, _react.useState)(0),
    _useState38 = _slicedToArray(_useState37, 2),
    end = _useState38[0],
    setEnd = _useState38[1];
  var pagination = [{
    label: 10,
    value: 10
  }, {
    label: 20,
    value: 20
  }, {
    label: 40,
    value: 40
  }, {
    label: 60,
    value: 60
  }, {
    label: 80,
    value: 80
  }, {
    label: 100,
    value: 100
  }];
  var _useState39 = (0, _react.useState)(0),
    _useState40 = _slicedToArray(_useState39, 2),
    total = _useState40[0],
    setTotal = _useState40[1];
  var _useState41 = (0, _react.useState)(1),
    _useState42 = _slicedToArray(_useState41, 2),
    totalPages = _useState42[0],
    setTotalPages = _useState42[1];
  var _useState43 = (0, _react.useState)([{
      verb: "GET",
      path: "/core/v1/event-notification-messages",
      name: "Retrieve event notifications you have subscribed to"
    }, {
      verb: "DELETE",
      path: "/core/v1/event-notification-messages/{adp-msg-msgid}",
      name: "Deletes an event notification message"
    }]),
    _useState44 = _slicedToArray(_useState43, 2),
    eventNotifyData = _useState44[0],
    setEventNotifyData = _useState44[1];
  var _useState45 = (0, _react.useState)({
      GET: 0,
      POST: 0,
      PUT: 0,
      ALL: 0
    }),
    _useState46 = _slicedToArray(_useState45, 2),
    tabCounts = _useState46[0],
    setTabCounts = _useState46[1];
  var _useState47 = (0, _react.useState)(0),
    _useState48 = _slicedToArray(_useState47, 2),
    tabActive = _useState48[0],
    setTabActive = _useState48[1]; // controls tab value render blocks as common fetcher for the next two declarations
  var _useState49 = (0, _react.useState)("Project APIs"),
    _useState50 = _slicedToArray(_useState49, 2),
    selectedTab = _useState50[0],
    setSelectedTab = _useState50[1]; // self-service
  var segments = [{
    label: "Project APIs (".concat(filteredApis.length || 0, ")"),
    value: 0,
    disabled: false
  }, {
    label: "Event Subscriptions (".concat(getEventApisCount() || 0, ")"),
    value: 1,
    disabled: false
  }]; // api-central

  var refIntoView = (0, _react.useRef)(null);
  var refIntoViewEvents = (0, _react.useRef)(null);
  var _useState51 = (0, _react.useState)(false),
    _useState52 = _slicedToArray(_useState51, 2),
    showCheckBoxes = _useState52[0],
    setShowCheckBoxes = _useState52[1];
  var _useState53 = (0, _react.useState)([]),
    _useState54 = _slicedToArray(_useState53, 2),
    checkBoxAPIs = _useState54[0],
    setCheckBoxAPIs = _useState54[1];
  var _useState55 = (0, _react.useState)(false),
    _useState56 = _slicedToArray(_useState55, 2),
    showEventsCheckBoxes = _useState56[0],
    setShowEventsCheckBoxes = _useState56[1];
  var _useState57 = (0, _react.useState)([]),
    _useState58 = _slicedToArray(_useState57, 2),
    checkBoxEventAPIs = _useState58[0],
    setCheckBoxEventAPIs = _useState58[1];
  var _useState59 = (0, _react.useState)(false),
    _useState60 = _slicedToArray(_useState59, 2),
    showCommitDialog = _useState60[0],
    setShowCommitDialog = _useState60[1];
  var resetAllButtons = function resetAllButtons() {
    if (tabActive === 0) {
      setShowCheckBoxes(false);
      setCheckBoxAPIs([]);
    }
    if (tabActive === 1) {
      setShowEventsCheckBoxes(false);
      setCheckBoxEventAPIs([]);
    }
  };
  var onSegmentChange = function onSegmentChange(event) {
    setSelectedSegment(event.detail); // passes value to parent
    setTabActive(event.detail);
    setSearchedText("");
  };
  function getEventApisCount() {
    return eventApisCount || 0;
  }
  function checkForNoResults() {
    return tabCounts[verbTab.toUpperCase()] === 0;
  }
  var handleError = function handleError(message) {
    setToast({
      key: (0, _lodash.uniqueId)(),
      status: "error",
      message: message,
      showToast: true
    });
  };
  var onSelectedTab = function onSelectedTab(event) {
    if (event.detail.value) {
      setSelectedTab(event.detail.value);
    }
  };
  (0, _react.useEffect)(function () {
    setSelectedTab("Project APIs");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  (0, _react.useEffect)(function () {}, [categorized, eventNotifyData, events]);
  (0, _react.useEffect)(function () {
    var arr = {};
    var apis = events;
    var count = 0;
    var liveCount = 0;
    for (var _i2 = 0, _Object$keys = Object.keys(apis); _i2 < _Object$keys.length; _i2++) {
      var key = _Object$keys[_i2];
      var temp = [];
      var _iterator = _createForOfIteratorHelper(apis[key]),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var api = _step.value;
          count += 1;
          if (searchEventNotification.length > 0) {
            if (api.path.toLowerCase().includes(searchEventNotification.toLowerCase())) {
              temp.push(api);
            }
          } else {
            temp.push(api);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (temp.length > 0) {
        arr[key] = temp;
        liveCount += temp.length || 0;
      }
    }
    setEventApisCount(count);
    setEventApis(arr);
  }, [searchEventNotification]);
  (0, _react.useEffect)(function () {
    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            setSpinner(true);
            _context2.next = 4;
            return doSearchTasks().then(function (r) {
              setSpinner(false);
            });
          case 4:
            _context2.next = 9;
            break;
          case 6:
            _context2.prev = 6;
            _context2.t0 = _context2["catch"](0);
            setCategorized({});
          case 9:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[0, 6]]);
    }))();
    return function () {
      // this now gets called when the component unmounts
    };
  }, [searchedText, verbTab, selectedCategory, pageSize, pageNo]);
  function doSearchTasks() {
    return _doSearchTasks.apply(this, arguments);
  }
  function _doSearchTasks() {
    _doSearchTasks = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            searchByTab(verbTab).then(function (r) {});
          case 1:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));
    return _doSearchTasks.apply(this, arguments);
  }
  (0, _react.useEffect)(function () {
    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var flattenedAPIs, total, totalPages, nonFlat;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            flattenedAPIs = Object.values(paginatedAPIs).flat();
            updateStartAndEnd(flattenedAPIs.length, pageNo, pageSize);
            total = flattenedAPIs ? flattenedAPIs.length : 1;
            totalPages = flattenedAPIs.length <= 0 ? 1 : Math.ceil(flattenedAPIs.length / pageSize);
            flattenedAPIs = flattenedAPIs.slice((pageNo - 1) * pageSize, pageNo * pageSize);
            nonFlat = (0, _apiUtils.categorizeAPIs)(flattenedAPIs);
            setCategorized(JSON.parse(JSON.stringify(nonFlat)));
            setTotal(total);
            setTotalPages(totalPages);
          case 9:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }))();
    return function () {
      // this now gets called when the component unmounts
    };
  }, [paginatedAPIs]);
  (0, _react.useEffect)(function () {
    setPageNo(1);
    setPageSize(10);
  }, [selectedCategory, verbTab, searchedText]);
  var updateStartAndEnd = function updateStartAndEnd(total, pageNo, pageSize) {
    setStart(total > 0 ? (pageNo - 1) * pageSize + 1 : 0);
    setEnd(pageNo * pageSize > total ? total : pageNo * pageSize);
  };
  var getCheckBoxAPIValue = function getCheckBoxAPIValue(api) {
    if (isTabOpen(0)) {
      if (checkBoxAPIs.length > 0) {
        var oldestSiblingAPI = checkBoxAPIs.filter(function (item) {
          return api.canonical === item.canonical && api.path === item.path;
        });
        if (oldestSiblingAPI.length > 0) {
          return oldestSiblingAPI[0].checkedAPI && !oldestSiblingAPI[0].hasOwnProperty("sibling");
        }
      }
    }
    if (isTabOpen(1)) {
      if (checkBoxEventAPIs.length > 0) {
        var match = checkBoxEventAPIs.filter(function (item) {
          return api.canonical === item.canonical && api.path === item.path;
        });
        if (match.length > 0) {
          return match[0].checkedAPI;
        }
      }
    }
    return false;
  };
  // Siblings do not apply to tab 1
  var hasSiblings = function hasSiblings(api) {
    var siblings = checkBoxAPIs.filter(function (item) {
      return item.canonical === api.canonical && item.path !== api.path;
    });
    if (siblings.length > 0) {
      return true;
    }
  };
  // Siblings do not apply to tab 1
  function isAPISibling(api) {
    var data = checkBoxAPIs.filter(function (item) {
      return item.canonical === api.canonical && item.path === api.path && item.sibling === true;
    });
    return data.length > 0;
  }
  function updateCategorizedCheckBoxedAPI(changedVal, api, key) {
    if (isTabOpen(1)) {
      var API = (0, _lodash.cloneDeep)(api);
      API.checkedAPI = changedVal;
      if (changedVal) {
        if (checkBoxEventAPIs.length > 0) {
          setCheckBoxEventAPIs([].concat(_toConsumableArray(checkBoxEventAPIs), [API]));
        } else {
          setCheckBoxEventAPIs([API]);
        }
      } else {
        var data = checkBoxEventAPIs.filter(function (item) {
          return api.canonical !== item.canonical;
        });
        setCheckBoxEventAPIs(_toConsumableArray(data));
      }
    }
    if (isTabOpen(0)) {
      var searchStr = api.canonical || "";
      var siblings = (0, _lodash.cloneDeep)(filteredApis).filter(function (item) {
        return item.canonical === searchStr && api.path !== item.path;
      });
      var _iterator2 = _createForOfIteratorHelper(siblings),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var apiFromSet = _step2.value;
          apiFromSet.sibling = changedVal;
          apiFromSet.checkedAPI = changedVal;
          apiFromSet.indeterminate = changedVal;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      api.checkedAPI = changedVal;
      if (changedVal) {
        if (checkBoxAPIs.length > 0) {
          setCheckBoxAPIs([].concat(_toConsumableArray(checkBoxAPIs), [api], _toConsumableArray(siblings)));
        } else {
          setCheckBoxAPIs([api].concat(_toConsumableArray(siblings)));
        }
      } else {
        var _data = checkBoxAPIs.filter(function (item) {
          return api.canonical !== item.canonical;
        });
        setCheckBoxAPIs(_toConsumableArray(_data));
      }
    }
  }
  // Siblings do not apply to tab 1
  function getSiblings(api) {
    var siblings = checkBoxAPIs.filter(function (item) {
      return item.canonical === api.canonical && item.path !== api.path;
    });
    if (siblings && siblings.length > 0) {
      return siblings;
    }
    return [];
  }
  function searchByTab(_x2) {
    return _searchByTab.apply(this, arguments);
  }
  function _searchByTab() {
    _searchByTab = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(verbTab) {
      var paginated, apis, verbCounts, _i3, _Object$keys4, key, visibleOnly, _iterator3, _step3, api, filtersApiMatch;
      return _regeneratorRuntime().wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            paginated = {};
            apis = categorizedAPIs;
            verbCounts = {
              GET: 0,
              POST: 0,
              PUT: 0,
              ALL: 0
            };
            for (_i3 = 0, _Object$keys4 = Object.keys(apis); _i3 < _Object$keys4.length; _i3++) {
              key = _Object$keys4[_i3];
              visibleOnly = [];
              _iterator3 = _createForOfIteratorHelper(apis[key]);
              try {
                for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                  api = _step3.value;
                  filtersApiMatch = false;
                  if (searchedText.length > 0) {
                    if (!api.hasOwnProperty("subCategory") || !api.hasOwnProperty("path") || !api.hasOwnProperty("name") || !api.hasOwnProperty("text")) {
                      // console.log('Skipping api, some props not present.');
                    } else if (api.path.toLowerCase().includes(searchedText.toLowerCase()) || api.name.toLowerCase().includes(searchedText.toLowerCase()) || api.text.toLowerCase().includes(searchedText.toLowerCase())) {
                      filtersApiMatch = searchHelper(api, verbTab, verbCounts);
                    } else {}
                  } else {
                    filtersApiMatch = searchHelper(api, verbTab, verbCounts);
                  }
                  api.visible = filtersApiMatch;
                  if (filtersApiMatch) {
                    visibleOnly.push(api); // showing this count
                  }
                }
              } catch (err) {
                _iterator3.e(err);
              } finally {
                _iterator3.f();
              }
              if (visibleOnly.length > 0) {
                paginated[key] = visibleOnly;
              }
              verbCounts["ALL"] = verbCounts["GET"] + verbCounts["POST"] + verbCounts["PUT"];
              setTabCounts(verbCounts);
            }
            setPaginatedAPIs(paginated);
          case 5:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    }));
    return _searchByTab.apply(this, arguments);
  }
  function searchHelper(api, verbTab, verbCounts) {
    var allowedVerbs = ["GET", "POST", "PUT"];
    var categoryMatch = selectedCategory && (selectedCategory.value.toLowerCase() === "all" || api.type.toLowerCase() === selectedCategory.value.toLowerCase());
    var verbMatch = verbTab.toLowerCase() === "all" || api.verb.toLowerCase() === verbTab.toLowerCase();
    if (categoryMatch) {
      // update counts
      if (allowedVerbs.includes(api.verb.toUpperCase())) {
        verbCounts[api.verb.toUpperCase()] = verbCounts[api.verb.toUpperCase()] + 1;
      }
    }
    return categoryMatch && verbMatch;
  }
  var isTabOpen = function isTabOpen(key) {
    var arr = {
      0: "Project APIs",
      1: "Event Subscriptions"
    };
    if ((0, _endpoints.isApiCentral)(projectApp) || (0, _endpoints.isSelfServiceSiProject)(projectApp)) {
      return tabActive === key;
    }
    if ((0, _endpoints.isSelfService)(projectApp)) {
      return selectedTab === arr[key];
    }
  };
  var onOperationApiExpandBox = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(api, key, index, arr, setArr) {
      var params, url, response, details, errorMessage;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            if ((0, _get.default)(arr[key][index], "details", null)) {
              _context4.next = 13;
              break;
            }
            arr[key][index] = _objectSpread(_objectSpread({}, arr[key][index]), {}, {
              open: true,
              loading: true
            });
            setArr(JSON.parse(JSON.stringify(arr)));
            params = {
              product: (0, _get.default)(projectDetail, "product.productCode", {}),
              method: api.verb
            };
            if (api.hasOwnProperty("eventCode")) {
              params.event = api.eventCode;
            } else {
              params.path = api.path;
            }
            url = (0, _endpoints.cleanPath)(_endpoints.URLS[projectAppForUrl]["get"]["operation-details"]);
            _context4.next = 9;
            return _devPortalContext.default.get(url, {
              params: params,
              paramsSerializer: function paramsSerializer(params) {
                return _qs.default.stringify(params, {
                  encode: true
                });
              }
            });
          case 9:
            response = _context4.sent;
            details = (0, _get.default)(response, "data", {});
            arr[key][index] = _objectSpread(_objectSpread({}, arr[key][index]), {}, {
              details: details,
              loading: false
            });
            setArr(JSON.parse(JSON.stringify(arr)));
          case 13:
            _context4.next = 21;
            break;
          case 15:
            _context4.prev = 15;
            _context4.t0 = _context4["catch"](0);
            arr[key][index] = _objectSpread(_objectSpread({}, arr[key][index]), {}, {
              loading: false
            });
            setArr(JSON.parse(JSON.stringify(arr)));
            errorMessage = (0, _get.default)(_context4.t0, "response.data.message", "Something went wrong while fetching operation api details. Please try again.");
            handleError(errorMessage);
          case 21:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[0, 15]]);
    }));
    return function onOperationApiExpandBox(_x3, _x4, _x5, _x6, _x7) {
      return _ref5.apply(this, arguments);
    };
  }();
  var onExpandableOperationBoxClose = function onExpandableOperationBoxClose(item, index, arr) {
    if (item === null) {
      arr[index] = _objectSpread(_objectSpread({}, arr[index]), {}, {
        open: false
      });
    } else {
      arr[item][index] = _objectSpread(_objectSpread({}, arr[item][index]), {}, {
        open: false
      });
    }
  };
  var onEventNotifyApiExpandBox = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(api, index) {
      var params, url, response, details, errorMessage;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            if ((0, _get.default)(eventNotifyData[index], "details", null)) {
              _context5.next = 12;
              break;
            }
            eventNotifyData[index] = _objectSpread(_objectSpread({}, eventNotifyData[index]), {}, {
              open: true,
              loading: true
            });
            setEventNotifyData(_toConsumableArray(eventNotifyData));
            params = {
              path: api.path,
              method: api.verb
            };
            url = (0, _endpoints.cleanPath)(_endpoints.URLS[projectAppForUrl]["get"]["operation-details"]);
            _context5.next = 8;
            return _devPortalContext.default.get(url, {
              params: params,
              paramsSerializer: function paramsSerializer(params) {
                return _qs.default.stringify(params, {
                  encode: true
                });
              }
            });
          case 8:
            response = _context5.sent;
            details = (0, _get.default)(response, "data", {});
            eventNotifyData[index] = _objectSpread(_objectSpread({}, eventNotifyData[index]), {}, {
              details: details,
              loading: false
            });
            setEventNotifyData(_toConsumableArray(eventNotifyData));
          case 12:
            _context5.next = 20;
            break;
          case 14:
            _context5.prev = 14;
            _context5.t0 = _context5["catch"](0);
            eventNotifyData[index] = _objectSpread(_objectSpread({}, eventNotifyData[index]), {}, {
              loading: false
            });
            setEventNotifyData(_toConsumableArray(eventNotifyData));
            errorMessage = (0, _get.default)(_context5.t0, "response.data.message", "Something went wrong while fetching Operation details. Please try again.");
            handleError(errorMessage);
          case 20:
          case "end":
            return _context5.stop();
        }
      }, _callee5, null, [[0, 14]]);
    }));
    return function onEventNotifyApiExpandBox(_x8, _x9) {
      return _ref6.apply(this, arguments);
    };
  }();
  function httpBadgeInternal(api) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "flex operations-overflow sm:justify-around items-center"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "order-1"
    }, /*#__PURE__*/_react.default.createElement(_reactComponents.SdfBadge, {
      className: "w-20",
      status: _apiUtils.VERB_TO_STATUS[api.verb] || "default"
    }, api.verb)), /*#__PURE__*/_react.default.createElement("div", {
      className: "order-2 w-full"
    }, /*#__PURE__*/_react.default.createElement("div", null, api.path, "\xA0", isAPISibling(api) ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactComponents.SdfTooltip, {
      trigger: "hover",
      state: "neutral",
      tooltipId: (0, _lodash.uniqueId)()
    }, /*#__PURE__*/_react.default.createElement("span", {
      slot: "tooltip-target",
      className: "overflow-ellipsis overflow-hidden"
    }, /*#__PURE__*/_react.default.createElement(_reactComponents.SdfIcon, {
      icon: "alert-info"
    })), /*#__PURE__*/_react.default.createElement("span", null, "This API was automatically selected because it belongs to a set of pre-bundled APIs."))) : null)));
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: showCheckBoxes && isTabOpen(0) || showEventsCheckBoxes && isTabOpen(1) ? "container-sticky" : ""
  }, /*#__PURE__*/_react.default.createElement("div", null, !hideHeader && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _endpoints.isSelfService)(projectApp) && /*#__PURE__*/_react.default.createElement("h3", {
    className: "text-heading-06 font-black"
  }, "Data connector APIs"), (0, _endpoints.isSelfService)(projectApp) && platform === "marketplace" && /*#__PURE__*/_react.default.createElement(_reactComponents.SdfTabGroup, {
    onSdfChange: function onSdfChange($event) {
      return onSelectedTab($event);
    }
  }, /*#__PURE__*/_react.default.createElement(_reactComponents.SdfTab, {
    value: "Project APIs",
    active: selectedTab === "Project APIs"
  }, "Project APIs ", /*#__PURE__*/_react.default.createElement(_reactComponents.SdfBadge, null, filteredApis.length || 0)), /*#__PURE__*/_react.default.createElement(_reactComponents.SdfTab, {
    value: "Event Subscriptions",
    active: selectedTab === "Event Subscriptions"
  }, "Event Subscriptions", /*#__PURE__*/_react.default.createElement(_reactComponents.SdfBadge, null, getEventApisCount() || 0))), ((0, _endpoints.isApiCentral)(projectApp) || (0, _endpoints.isSelfServiceSiProject)(projectApp)) && /*#__PURE__*/_react.default.createElement("div", {
    className: "flex my-10 justify-center"
  }, /*#__PURE__*/_react.default.createElement(_reactComponents.SdfSegmentedControl, {
    items: segments,
    onSdfChange: function onSdfChange(event) {
      return onSegmentChange(event);
    },
    selectedIndex: tabActive
  })))), legacy && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h3", {
    className: "text-heading-04 font-bold"
  }, "Legacy project"), /*#__PURE__*/_react.default.createElement("p", {
    className: "text-body-02"
  }, (0, _endpoints.isApiCentral)(projectApp) ? _constants.API_CENTRAL_LEGACY_TEXT : _constants.SELF_SERVICE_LEGACY_TEXT), /*#__PURE__*/_react.default.createElement("div", {
    className: "mt-10 mb-10"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "font-bold"
  }, "API Endpoint: "), "https://api.adp.com/API_path")), isTabOpen(0) && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !hideHeader && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !legacy && /*#__PURE__*/_react.default.createElement("div", {
    className: "mt-8"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex justify-between items-center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "text-heading-05 font-bold"
  }, "Project APIs (", filteredApis.length || 0, ")"), !openFocusPane && /*#__PURE__*/_react.default.createElement(_reactComponents.SdfLink, {
    href: useCaseDocument || firstDocument,
    target: "_blank"
  }, /*#__PURE__*/_react.default.createElement(_reactComponents.SdfIcon, {
    icon: "external-link"
  }), " View Documentation"), openFocusPane && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_reactComponents.SdfLink, {
    className: "cursor-pointer mr-5",
    slot: "breadcrumb",
    onClick: function onClick() {
      return history.push(changeHistoryRedirectUrl);
    },
    disabled: (projectDetail === null || projectDetail === void 0 ? void 0 : projectDetail.commitChangesCount) === 0 || showCheckBoxes
  }, "View change history"), (filteredApis === null || filteredApis === void 0 ? void 0 : filteredApis.length) > 0 && !showCheckBoxes && (0, _endpoints.isApiCentral)(projectApp) && /*#__PURE__*/_react.default.createElement(_reactComponents.SdfButton, _extends({
    className: "cursor-pointer mr-5",
    emphasis: "secondary"
  }, disableAddApisBtn && {
    disabled: true
  }, {
    onClick: function onClick() {
      setShowCheckBoxes(true);
      if (refIntoView && refIntoView.current) {
        refIntoView.current.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      }
    }
  }), "Remove APIs"), showCheckBoxes && (0, _endpoints.isApiCentral)(projectApp) && /*#__PURE__*/_react.default.createElement(_reactComponents.SdfButton, {
    className: "cursor-pointer mr-5",
    emphasis: "secondary",
    disabled: true
  }, "Remove APIs"), /*#__PURE__*/_react.default.createElement(_reactComponents.SdfButton, _extends({
    emphasis: "primary",
    busy: isDomainSubCategoryBusy
  }, (showCheckBoxes || disableAddApisBtn) && {
    disabled: true
  }, {
    onClick: function onClick() {
      openFocusPane(true);
    }
  }), isTabOpen(0) ? "Add more APIs" : "Add Event Subscriptions"))), /*#__PURE__*/_react.default.createElement("h3", {
    className: "text-heading-04 font-bold"
  }, caseDisplay), /*#__PURE__*/_react.default.createElement("p", {
    className: "text-body-02"
  }, caseDescription || "NA"), (0, _endpoints.isSelfService)(projectApp) && /*#__PURE__*/_react.default.createElement("div", {
    className: "flex justify-between items-center mb-10"
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", {
    className: "font-bold"
  }, "API Endpoint: "), "https://api.adp.com/{API_path}"), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex items-start"
  }, /*#__PURE__*/_react.default.createElement(_reactComponents.SdfIcon, {
    className: "mr-1 text-action-primary cursor-pointer",
    icon: "external-link"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "text-action-primary cursor-pointer"
  }, "Need more APIs?")), /*#__PURE__*/_react.default.createElement(_reactComponents.SdfFloatingPane, {
    "show-arrow": true,
    "auto-attach": true,
    portalEnabled: true,
    offset: 5,
    className: "z-0"
  }, /*#__PURE__*/_react.default.createElement(_reactComponents.SdfBox, {
    variant: "clear",
    className: "gap-8"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "text-heading-04 font-bold font-default"
  }, "Need more APIs?"), /*#__PURE__*/_react.default.createElement("div", {
    className: "mt-4 w-md text-body-02"
  }, "Submit a ticket and tell us what APIs you would like access to. Our technical advisor team will reach out to you once your request is processed."), /*#__PURE__*/_react.default.createElement("div", {
    className: "mt-6 flex col-gap-6"
  }, /*#__PURE__*/_react.default.createElement(_reactComponents.SdfLink, {
    emphasis: "secondary",
    href: _endpoints.DEV_PORTAL_GUIDES,
    target: "_blank"
  }, "Learn more about ADP APIs"), /*#__PURE__*/_react.default.createElement(_reactComponents.SdfLink, {
    emphasis: "primary",
    href: _endpoints.ZENDESK_LINK,
    target: "_blank"
  }, "SUBMIT A TICKET"))))), ((0, _endpoints.isApiCentral)(projectApp) || (0, _endpoints.isSelfServiceSiProject)(projectApp)) && /*#__PURE__*/_react.default.createElement("div", {
    className: "flex justify-between items-center mb-4"
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", {
    className: "font-bold"
  }, "API Endpoint: "), "https://api.adp.com/{API_path}")))), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex-col flex w-auto justify-between",
    ref: refIntoView
  }, !hideHeader && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !(0, _endpoints.isSelfServiceSiProject)(projectApp) && hasFilteredApis && projectDetail && /*#__PURE__*/_react.default.createElement(_promoBoxes.default, {
    projectIdEncrypted: (0, _get.default)(projectDetail, "_id", ""),
    projectName: (0, _get.default)(projectDetail, "name", ""),
    caseId: (0, _get.default)(projectDetail, "caseID", ""),
    sor: (0, _get.default)(projectDetail, "product.productCode", {}),
    productName: (0, _get.default)(projectDetail, "product.name", "NA"),
    filteredApis: filteredApis,
    history: history,
    host: host,
    projectApp: projectApp,
    disabled: showCheckBoxes
  }), showCheckBoxes && (0, _endpoints.isApiCentral)(projectApp) && /*#__PURE__*/_react.default.createElement("div", {
    className: showCheckBoxes ? "sticky-thc" : ""
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex justify-between items-center mt-2"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "text-heading-05 font-bold"
  }, "Remove APIs from project"), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactComponents.SdfLink, {
    className: "cursor-pointer mr-5",
    slot: "breadcrumb",
    onClick: function onClick() {
      setShowCheckBoxes(false);
      setCheckBoxAPIs([]);
    }
  }, "Cancel changes")), checkBoxAPIs && showCheckBoxes && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactComponents.SdfButton, {
    className: "cursor-pointer mr-5",
    emphasis: "primary",
    onClick: function onClick() {
      // call COMMIT CHANGES POST API CALL
      if (checkBoxAPIs && checkBoxAPIs.length > 0) {
        setShowCommitDialog(true);
      }
    }
  }, "Apply Changes (", checkBoxAPIs.length || 0, ")")))), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex mt-2 mb-2"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "text-body-02"
  }, "Select the checkbox next to the APIs below that you want to remove and then select the \u2018apply changes\u2019 button to confirm.")))), /*#__PURE__*/_react.default.createElement("div", {
    className: showCheckBoxes ? "bg-info-25 px-4" : ""
  }, /*#__PURE__*/_react.default.createElement(_search.default, {
    searchedText: searchedText,
    setSearchedText: setSearchedText,
    setSelectedCategory: setSelectedCategory,
    selectedCategory: selectedCategory,
    refIntoView: refIntoView
  }), categorized && /*#__PURE__*/_react.default.createElement("div", {
    className: "mb-4"
  }, /*#__PURE__*/_react.default.createElement(_reactComponents.SdfTabGroup, {
    size: "small",
    onSdfChange: /*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(event) {
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              setVerbTab(event.detail.value);
              _context6.next = 3;
              return new Promise(function (res) {
                return setTimeout(res, 100);
              });
            case 3:
              if (refIntoView && refIntoView.current) {
                refIntoView.current.scrollIntoView({
                  behavior: "smooth",
                  block: "start"
                });
              }
            case 4:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }));
      return function (_x10) {
        return _ref7.apply(this, arguments);
      };
    }()
  }, /*#__PURE__*/_react.default.createElement(_reactComponents.SdfTab, {
    value: "ALL",
    active: verbTab === "ALL"
  }, "ALL (", tabCounts["ALL"] || 0, ")"), /*#__PURE__*/_react.default.createElement(_reactComponents.SdfTab, {
    value: "GET",
    active: verbTab === "GET"
  }, "GET (", tabCounts["GET"] || 0, ")"), /*#__PURE__*/_react.default.createElement(_reactComponents.SdfTab, {
    value: "POST",
    active: verbTab === "POST"
  }, "POST (", tabCounts["POST"] || 0, ")"), /*#__PURE__*/_react.default.createElement(_reactComponents.SdfTab, {
    value: "PUT",
    active: verbTab === "PUT"
  }, "PUT (", tabCounts["PUT"] || 0, ")")), /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: "uppercase text-heading-04 mt-4 font-bold"
  }, verbTab), /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, checkForNoResults() && /*#__PURE__*/_react.default.createElement("div", {
    className: "mt-4"
  }, "No matching Project APIs found")), spinner ? /*#__PURE__*/_react.default.createElement("section", {
    className: "flex items-center justify-center h-full p-8 flex-col gap-8 relative"
  }, /*#__PURE__*/_react.default.createElement(_reactComponents.SdfBusyIndicator, {
    id: "demo-component",
    size: "md"
  }), /*#__PURE__*/_react.default.createElement(_reactComponents.SdfButton, {
    id: "fullscreen-button"
  }, "Show Full Screen for 5 seconds")) : categorized && Object.keys(categorized).length > 0 && ((_Object$keys2 = Object.keys(categorized)) === null || _Object$keys2 === void 0 ? void 0 : _Object$keys2.map(function (item) {
    var _categorized$item;
    return (0, _apiUtils.hasOneVisibleApi)(categorized[item]) && /*#__PURE__*/_react.default.createElement("div", {
      key: item,
      className: "apiView"
    }, !item.toLowerCase().includes("null/null") && /*#__PURE__*/_react.default.createElement("div", {
      key: item,
      className: "mt-6 mb-6"
    }, /*#__PURE__*/_react.default.createElement("div", {
      key: item,
      className: "capitalize"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: item.split("/")[0].length <= 3 ? "uppercase text-heading-03 font-bold" : "text-heading-03 font-bold"
    }, item.split("/")[0] || ""), /*#__PURE__*/_react.default.createElement("sdf-icon", {
      className: "cursor-pointer no-underline hover:no-underline",
      icon: "nav-page-next"
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: "text-body-03 font-semi-black"
    }, item.split("/")[1] || ""))), (_categorized$item = categorized[item]) === null || _categorized$item === void 0 ? void 0 : _categorized$item.map(function (api, index) {
      var _getSiblings;
      return api.visible && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: "flex items-center"
      }, showCheckBoxes && (0, _endpoints.isApiCentral)(projectApp) && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !(0, _apiUtils.apiToHide)(api.path) ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (getCheckBoxAPIValue(api) || checkBoxAPIs.length === 0) && !isAPISibling(api) ? /*#__PURE__*/_react.default.createElement(_reactComponents.SdfCheckbox, {
        className: "mt-2 ml-3 order-1",
        checked: getCheckBoxAPIValue(api),
        onSdfChange: function onSdfChange(_ref8) {
          var detail = _ref8.detail;
          updateCategorizedCheckBoxedAPI(detail, api, item);
        }
      }) : !isAPISibling(api) ? /*#__PURE__*/_react.default.createElement(_reactComponents.SdfCheckbox, {
        className: "mt-2 ml-3 order-1",
        checked: getCheckBoxAPIValue(api),
        onSdfChange: function onSdfChange(_ref9) {
          var detail = _ref9.detail;
          updateCategorizedCheckBoxedAPI(detail, api, item);
        }
      }) : /*#__PURE__*/_react.default.createElement(_reactComponents.SdfCheckbox, {
        className: "mt-2 ml-3 order-1",
        indeterminate: isAPISibling(api),
        disabled: isAPISibling(api),
        onSdfChange: function onSdfChange(_ref10) {
          var detail = _ref10.detail;
          updateCategorizedCheckBoxedAPI(detail, api, item);
        }
      })) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactComponents.SdfCheckbox, {
        className: "mt-2 ml-3 order-1",
        disabled: true
      }))), /*#__PURE__*/_react.default.createElement("div", {
        key: "operation-details-".concat(item, "-").concat(index),
        className: "h-auto mt-2 order-2 w-full"
      }, /*#__PURE__*/_react.default.createElement(_reactComponents.SdfExpandableBox, {
        key: "operation-".concat(item, "-").concat(index),
        opened: !!api.open,
        className: "mb-2",
        variant: "shadowed",
        triggerPlacement: "after",
        stroke: "light",
        headingLevel: "3",
        onSdfClose: function onSdfClose(e) {
          onExpandableOperationBoxClose(item, index, categorized);
        },
        onSdfOpen: function onSdfOpen(e) {
          onOperationApiExpandBox(api, item, index, categorized, setCategorized).then(function (r) {});
        }
      }, api.loading && /*#__PURE__*/_react.default.createElement(_reactComponents.SdfShimmer, {
        key: "shimmer-".concat(item, "-").concat(index),
        rows: 4
      }), !api.loading && !!api.open && /*#__PURE__*/_react.default.createElement(_operationTabContent.default, {
        key: "operation-details-content-".concat(item, "-").concat(index),
        operationDetails: (0, _get.default)(api, "details", {}),
        description: (0, _get.default)(api, "details.description", api.name)
      }), /*#__PURE__*/_react.default.createElement("div", {
        slot: "header",
        key: "badge-".concat(item, "-").concat(index),
        className: "w-full flex flex-row justify-between items-center"
      }, /*#__PURE__*/_react.default.createElement("div", {
        key: "verb-".concat(item, "-").concat(index),
        className: "flex flex-row gap-4 items-end items-center w-full"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "text-heading-04 font-bold w-full"
      }, httpBadgeInternal(api))), /*#__PURE__*/_react.default.createElement("div", {
        className: "order-3"
      }, api.type && api.type.toLowerCase() !== "regular" && /*#__PURE__*/_react.default.createElement("div", {
        className: ""
      }, /*#__PURE__*/_react.default.createElement(_reactComponents.SdfBox, {
        key: "".concat(api.path, "-").concat(api.type),
        variant: "filled",
        fill: "shaded",
        shape: "rounded",
        layout: "horizontal",
        className: "".concat((0, _apiUtils.getClassForTag)(api.type), " items-center font-normal uppercase"),
        style: {
          height: "10px"
        }
      }, /*#__PURE__*/_react.default.createElement("span", null, api.type)))))))), showCheckBoxes && checkBoxAPIs.length > 0 && getCheckBoxAPIValue(api) && !isAPISibling(api) && hasSiblings(api) && /*#__PURE__*/_react.default.createElement("section", {
        "data-cvs-id": "2",
        className: "flex items-center justify-center h-full"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "order-1 ml-10 "
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "order-2 w-full mt-2"
      }, /*#__PURE__*/_react.default.createElement("sdf-alert", {
        "data-cvs-id": "3",
        id: "parent-api-alertbox",
        status: "info",
        type: "banner",
        size: "sm",
        closeable: true
      }, /*#__PURE__*/_react.default.createElement("span", {
        "data-cvs-id": "4"
      }, "You have selected an API that belongs to a pre-bundled set of APIs. As a result, more than one API has been selected on your behalf as indicated by the dash symbol."), /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, hasSiblings(api) && ((_getSiblings = getSiblings(api)) === null || _getSiblings === void 0 ? void 0 : _getSiblings.map(function (item, index) {
        return /*#__PURE__*/_react.default.createElement("div", null, item.path);
      }))), /*#__PURE__*/_react.default.createElement("span", {
        "data-cvs-id": "6",
        slot: "title"
      }, "Be advised")))));
    }));
  })))), categorized && /*#__PURE__*/_react.default.createElement("div", {
    className: "flex items-center justify-end pt-4 pb-20"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "text-sm text-action-default"
  }, "Rows per page:"), /*#__PURE__*/_react.default.createElement(_reactComponents.SdfSelect, {
    className: "w-20 text-sm text-action-default px-4 mb-1 border-r-1 border-t-0 border-l-0 border-b-0 border-dark border-solid",
    items: pagination,
    onSdfChange: function onSdfChange(_ref11) {
      var detail = _ref11.detail;
      setPageSize(detail.value);
      setPageNo(1);
    },
    value: {
      label: "".concat(pageSize),
      value: pageSize
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "text-sm text-action-default px-4"
  }, "".concat(start, " - ").concat(end, " items")), /*#__PURE__*/_react.default.createElement(_reactComponents.SdfxPagination, {
    currentPage: pageNo || 1
    // totalPages={Math.ceil(total / pageSize) || 0}
    ,
    totalPages: totalPages || 0,
    onSdfxPageChange: function onSdfxPageChange(_ref12) {
      var detail = _ref12.detail;
      return setPageNo(detail);
    }
  })))))), isTabOpen(1) && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex justify-between items-center mb-6"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _endpoints.isSelfService)(projectApp) ? "text-heading-05 font-bold mt-6" : "text-heading-05 font-bold"
  }, "Event subscriptions (", getEventApisCount() || 0, ")"), openFocusPane && !legacy && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_reactComponents.SdfLink, {
    className: "cursor-pointer mr-5",
    slot: "breadcrumb",
    onClick: function onClick() {
      return history.push(changeHistoryRedirectUrl);
    },
    disabled: (projectDetail === null || projectDetail === void 0 ? void 0 : projectDetail.commitChangesCount) === 0 || showEventsCheckBoxes
  }, "View change history"), !showEventsCheckBoxes && (0, _endpoints.isApiCentral)(projectApp) && /*#__PURE__*/_react.default.createElement(_reactComponents.SdfButton, _extends({
    className: "cursor-pointer mr-5",
    emphasis: "secondary"
  }, disableAddApisBtn && {
    disabled: true
  }, {
    onClick: function onClick() {
      setShowEventsCheckBoxes(true);
      if (refIntoViewEvents && refIntoViewEvents.current) {
        refIntoViewEvents.current.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      }
    }
  }), "Remove Event Subscriptions"), showEventsCheckBoxes && (0, _endpoints.isApiCentral)(projectApp) && /*#__PURE__*/_react.default.createElement(_reactComponents.SdfButton, {
    className: "cursor-pointer mr-5",
    emphasis: "secondary",
    disabled: true,
    onClick: function onClick() {
      setShowEventsCheckBoxes(true);
    }
  }, "Remove Event Subscriptions"), /*#__PURE__*/_react.default.createElement(_reactComponents.SdfButton, _extends({
    emphasis: "primary",
    busy: isDomainSubCategoryBusy
  }, (disableAddApisBtn || showEventsCheckBoxes) && {
    disabled: true
  }, {
    onClick: function onClick() {
      openFocusPane(true);
    }
  }), isTabOpen(0) ? "Add more APIs" : "Add Event Subscriptions"))), /*#__PURE__*/_react.default.createElement("div", {
    className: "grid xl:grid-cols md:grid-cols-1 gap-10"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-span-2"
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("section", {
    className: ""
  }, /*#__PURE__*/_react.default.createElement(_reactComponents.SdfExpandableBox, {
    id: "FAQ",
    header: "Before you begin",
    opened: "true"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "ml-4 mr-4",
    id: "contents"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex w-full float-right justify-end"
  }, /*#__PURE__*/_react.default.createElement(_reactComponents.SdfLink, {
    target: "_blank",
    emphasis: "none",
    href: _endpoints.learnMoreLink
  }, "Learn more"))), /*#__PURE__*/_react.default.createElement("div", {
    className: "mt-2"
  }, /*#__PURE__*/_react.default.createElement("p", null, "1. Schema of an event notification varies depends on /events/eventNameCode/codeValue as well as the ADP product. Once you identify the event notification(s) to subscribe for your application, you should analyze the response payload and map out interested resources."), /*#__PURE__*/_react.default.createElement("p", null, "2. We recommend your application to use event notifications as a trigger instead of true source of real-time data as there is always a time lag between when a notification was generated and when your application retrieves it. For example, if a notification indicates a worker is hired, your application should do GET /hr/v2/workers/", "{aoid} ", "to retrieve the real-time data for the worker instead of relying on the value provided in the worker.hire notification as the data may have changed since the notification was generated."), /*#__PURE__*/_react.default.createElement("p", null, "3. About effective dating - in most cases, when a change has an effective date, the notification is generated at the time when the change is issued, not on the effective date. Your application should be able to look up the effective date in the notification response payload.")))))), /*#__PURE__*/_react.default.createElement("p", null, "When data is updated in an ADP application, ADP generates an event notification message. The message is then sent to a subscriber's message queue. To regularly check and retrieve event notification messages, subscribe your application to data change events. For example, you can subscribe to the Worker Hire event to be notified when a new hire is added to an ADP product. This is so you can do some work with the new hire's data."), eventNotifyData !== null && eventNotifyData.map(function (api, index) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: "operation-details-".concat(api.path),
      className: "h-auto"
    }, /*#__PURE__*/_react.default.createElement(_reactComponents.SdfExpandableBox, {
      opened: !!api.open,
      className: "mb-4",
      variant: "shadowed",
      triggerPlacement: "after",
      stroke: "light",
      headingLevel: "3",
      onSdfClose: function onSdfClose(e) {
        onExpandableOperationBoxClose(null, index, eventNotifyData);
      },
      onSdfOpen: function onSdfOpen(e) {
        onEventNotifyApiExpandBox(api, index).then(function (r) {});
      }
    }, api.loading && /*#__PURE__*/_react.default.createElement(_reactComponents.SdfShimmer, {
      rows: 4
    }), !api.loading && !!api.open && /*#__PURE__*/_react.default.createElement(_operationTabContent.default, {
      key: "operation-details-event-content-".concat(index),
      operationDetails: (0, _get.default)(api, "details", {}),
      description: api.name
    }), /*#__PURE__*/_react.default.createElement("div", {
      slot: "header",
      className: "w-full flex flex-row justify-between items-start"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "flex flex-row gap-4 items-start"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "text-heading-04 font-bold"
    }, (0, _apiUtils.httpBadge)(api))))));
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "line mt-10 mb-6"
  }), showEventsCheckBoxes && /*#__PURE__*/_react.default.createElement("div", {
    className: showEventsCheckBoxes ? "sticky-thc" : ""
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex justify-between items-center mt-2"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "text-heading-05 font-bold"
  }, "Remove Event Subscriptions"), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactComponents.SdfLink, {
    className: "cursor-pointer mr-5",
    slot: "breadcrumb",
    onClick: function onClick() {
      setShowEventsCheckBoxes(false);
      setCheckBoxEventAPIs([]);
    }
  }, "Cancel changes")), checkBoxEventAPIs && showEventsCheckBoxes && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactComponents.SdfButton, {
    className: "cursor-pointer mr-5",
    emphasis: "primary",
    onClick: function onClick() {
      // call COMMIT CHANGES POST API CALL
      if (checkBoxEventAPIs && checkBoxEventAPIs.length > 0) {
        setShowCommitDialog(true);
      }
    }
  }, "Apply Changes (", checkBoxEventAPIs.length || 0, ")")))), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex mt-2 mb-4"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "text-body-02"
  }, "Select the checkbox next to the subscribed events below you wish to remove, and then select the \u2018apply changes\u2019 button to confirm and remove from your project."))), /*#__PURE__*/_react.default.createElement("div", {
    className: showEventsCheckBoxes ? "bg-info-25 px-2" : ""
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex justify-between align-middle gap-6 pb-4",
    ref: refIntoViewEvents
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "text-heading-04 font-bold flex items-center"
  }, "Subscribed events (", getEventApisCount() || 0, ")"), /*#__PURE__*/_react.default.createElement(_reactComponents.SdfInput, {
    placeholder: "Search...",
    className: "w-2/8",
    onSdfInput: function onSdfInput(event) {
      return setSearchEventNotification(event.detail);
    },
    value: searchEventNotification
  })), /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, getEventApisCount() === 0 && /*#__PURE__*/_react.default.createElement("div", {
    className: "mt-4"
  }, "No matching Event Subscriptions found")), eventApis && Object.keys(eventApis).length > 0 && ((_Object$keys3 = Object.keys(eventApis)) === null || _Object$keys3 === void 0 ? void 0 : _Object$keys3.map(function (item, index) {
    var _eventApis$item;
    return /*#__PURE__*/_react.default.createElement("div", {
      key: item,
      className: "apiView"
    }, !item.toLowerCase().includes("null/null") && /*#__PURE__*/_react.default.createElement("div", {
      key: item,
      className: "".concat(index === 0 ? "mb-6" : "mt-6 mb-6")
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "capitalize"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: item.split("/")[0].length <= 3 ? "uppercase text-heading-03 font-bold" : "text-heading-03 font-bold"
    }, item.split("/")[0] || ""), /*#__PURE__*/_react.default.createElement("sdf-icon", {
      className: "cursor-pointer no-underline hover:no-underline",
      icon: "nav-page-next"
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: "text-body-03 font-semi-black"
    }, item.split("/")[1]))), (_eventApis$item = eventApis[item]) === null || _eventApis$item === void 0 ? void 0 : _eventApis$item.map(function (api, index) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "flex items-center"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "order-1"
      }, showEventsCheckBoxes && (0, _endpoints.isApiCentral)(projectApp) && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, getCheckBoxAPIValue(api) && checkBoxEventAPIs.length === 0 ? /*#__PURE__*/_react.default.createElement(_reactComponents.SdfCheckbox, {
        className: "mt-2 ml-3 order-1",
        checked: getCheckBoxAPIValue(api),
        onSdfChange: function onSdfChange(_ref13) {
          var detail = _ref13.detail;
          updateCategorizedCheckBoxedAPI(detail, api, item);
        }
      }) : /*#__PURE__*/_react.default.createElement(_reactComponents.SdfCheckbox, {
        className: "mt-2 ml-3 order-1",
        checked: getCheckBoxAPIValue(api),
        onSdfChange: function onSdfChange(_ref14) {
          var detail = _ref14.detail;
          updateCategorizedCheckBoxedAPI(detail, api, item);
        }
      }))), /*#__PURE__*/_react.default.createElement("div", {
        key: "operation-details-".concat(index),
        className: "order-2 h-auto mt-2 w-screen"
      }, /*#__PURE__*/_react.default.createElement(_reactComponents.SdfExpandableBox, {
        opened: !!api.open,
        className: "mb-2",
        variant: "shadowed",
        triggerPlacement: "after",
        stroke: "light",
        headingLevel: "3",
        onSdfClose: function onSdfClose(e) {
          onExpandableOperationBoxClose(item, index, eventApis);
        },
        onSdfOpen: function onSdfOpen(e) {
          onOperationApiExpandBox(api, item, index, eventApis, setEventApis).then(function (r) {});
        }
      }, api.loading && /*#__PURE__*/_react.default.createElement(_reactComponents.SdfShimmer, {
        rows: 4
      }), !api.loading && !!api.open && /*#__PURE__*/_react.default.createElement(_eventCodeTabContent.default, {
        key: "operation-details-content-".concat(index),
        index: index,
        operationDetails: (0, _get.default)(api, "details", {}),
        description: (0, _get.default)(api, "details.description", api.name)
      }), /*#__PURE__*/_react.default.createElement("div", {
        slot: "header",
        className: "w-full flex flex-row justify-between items-start"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "flex flex-row gap-4 items-start"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "text-heading-04 font-bold"
      }, api.eventCode))))));
    }));
  }))))))), loading && /*#__PURE__*/_react.default.createElement(_reactComponents.SdfBusyIndicator, {
    style: {
      color: "#1a8099"
    },
    size: "sm",
    overlay: false,
    fullScreen: false
  }), toast && /*#__PURE__*/_react.default.createElement(_toast.default, {
    key: toast.key,
    status: toast.status,
    message: toast.message,
    showToast: toast.showToast
  }), showCommitDialog && (0, _endpoints.isApiCentral)(projectApp) && (checkBoxAPIs.length > 0 || checkBoxEventAPIs.length > 0) && /*#__PURE__*/_react.default.createElement(_commitChanges.default, {
    setCommitDialog: setShowCommitDialog,
    data: isTabOpen(0) ? checkBoxAPIs : checkBoxEventAPIs,
    tabActive: isTabOpen(0) ? 0 : 1,
    scopeLastModified: scopeLastModified,
    existingEvents: existingEvents,
    existingAPIs: existingAPIs,
    projectIdEncrypted: projectIdEncrypted,
    consumerApplicationID: consumerApplicationID,
    host: host,
    refreshProjectConsumerDetails: refreshProjectConsumerDetails,
    reset: resetAllButtons,
    setToast: setToast
  })));
}